import React, { useMemo, useState } from 'react';
import useFirestore from '../../hooks/useFirestore';
import Table from '../../components/Table/Table';
import Modal from '../../components/Modal/Modal';
import styles from './Customers.module.css';

export default function Customers() {
  const { data: customers, loading } = useFirestore('customers');
  const { data: orders } = useFirestore('orders');
  const [selected, setSelected] = useState(null);

  const customerOrders = useMemo(() => {
    if (!selected) return [];
    return orders.filter((o) => o.customerName === selected.name);
  }, [selected, orders]);

  const columns = [
    {
      key: 'name',
      label: 'العميل',
      render: (row) => (
        <div className={styles.customerCell}>
          <span className={styles.avatar}>{row.name?.charAt(0)}</span>
          <span>{row.name}</span>
        </div>
      ),
    },
    { key: 'phone', label: 'رقم الهاتف' },
    { key: 'city', label: 'المدينة' },
    {
      key: 'actions',
      label: '',
      render: (row) => (
        <button className={styles.viewBtn} onClick={() => setSelected(row)}>عرض الطلبات</button>
      ),
    },
  ];

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <h2>العملاء</h2>
        <p>قائمة عملاء المتجر ({customers.length} عميل)</p>
      </div>

      <Table columns={columns} data={customers} loading={loading} emptyText="لا يوجد عملاء مسجلين بعد" />

      <Modal
        isOpen={!!selected}
        onClose={() => setSelected(null)}
        title={selected ? `طلبات ${selected.name}` : ''}
      >
        {customerOrders.length === 0 ? (
          <p className={styles.noOrders}>لا توجد طلبات لهذا العميل بعد</p>
        ) : (
          <ul className={styles.orderList}>
            {customerOrders.map((o) => (
              <li key={o.id}>
                <span>#{o.id.slice(0, 6)}</span>
                <span className="nums">{o.total} ج.م</span>
              </li>
            ))}
          </ul>
        )}
      </Modal>
    </div>
  );
}
